import api from "./api";
import endpoints from "./endpoints";

export default {
  get() {
    const response = api.get(endpoints.alternativeArticleNumberTypes.get).then((x) => x.data);
    return response;
  },
  async update(alternativeArticleNumberTypes) {
    const response = await api.post(endpoints.alternativeArticleNumberTypes.update, alternativeArticleNumberTypes);
    return response.data;
  },
  async delete(items) {
    const x = await api.post(endpoints.alternativeArticleNumberTypes.delete, items);
    return await Promise.resolve(x.data);
  }
};
